export class OrderBody {
    constructor(APIOrderOptions, billingAddressId, shippingAddressId, description, billingEmail, po) {
        this.APIOrderOptions = APIOrderOptions;
        this.billingAddressId = billingAddressId;
        this.shippingAddressId = shippingAddressId;
        this.description = description;
        this.billingEmail = billingEmail;
        this.po = po;
    }
}